import React, { useState } from "react";

export default function Sidebar({ active, onChange, sidebarOpen }) {
    const [websiteOpen, setWebsiteOpen] = useState(false);


    return (
        <div className={`sidebar d-flex flex-column p-3 ${sidebarOpen ? "show" : ""}`}>

            {/* MAIN NAV */}
            <button
                className={`nav-btn ${active === "Dashboard" ? "active" : ""}`}
                onClick={() => onChange("Dashboard")}
            >
                <i className="bi bi-grid-fill me-2 text-purple"></i> Dashboard
            </button>
            <button
                className={`nav-btn ${active === "MyListings" ? "active" : ""}`}
                onClick={() => onChange("MyListings")}
            >
                <i className="bi bi-card-list me-2 text-green"></i> Listing
            </button>








            {/* WEBSITE MENU */}
            <button
                className="nav-btn d-flex justify-content-between align-items-center"
                onClick={() => setWebsiteOpen(!websiteOpen)}
            >
                <span>
                    <i className="bi bi-globe2 me-2 text-red"></i> Website
                </span>
                <i className={`bi ${websiteOpen ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
            </button>

            {websiteOpen && (
                <div className="sub-menu ps-4">

                    <button
                        className={`sub-link nav-btn ${active === "WebHome" ? "active" : ""}`}
                        onClick={() => onChange("WebHome")}
                    >
                        Home
                    </button>

                    <button
                        className={`sub-link nav-btn ${active === "WebAboutMe" ? "active" : ""}`}
                        onClick={() => onChange("WebAboutMe")}
                    >
                        About Me
                    </button>

                    <button
                        className={`sub-link nav-btn ${active === "WebPortfolio" ? "active" : ""}`}
                        onClick={() => onChange("WebPortfolio")}
                    >
                        Portfolio
                    </button>

                    <button
                        className={`sub-link nav-btn ${active === "WebBiography" ? "active" : ""}`}
                        onClick={() => onChange("WebBiography")}
                    >
                        Biography
                    </button>

                    <button
                        className={`sub-link nav-btn ${active === "WebContactMe" ? "active" : ""}`}
                        onClick={() => onChange("WebContactMe")}
                    >
                        Contact Me
                    </button>
                </div>
            )}



            <style>{`
                /* Sidebar Container */
                .sidebar {
                    width: 100%;
                    background: linear-gradient(180deg, #ffffff, #f7faff);
                    border-right: 1px solid #ececec;
                    height: 100%;
                }

                .nav-btn {
                    width: 100%;
                    border: none;
                    background: transparent;
                    padding: 12px;
                    font-size: 15px;
                    text-align: left;
                    border-radius: 8px;
                    margin-bottom: 8px;
                    color: #444;
                    cursor: pointer;
                    display: block;
                    text-decoration: none;
                    transition: 0.2s;
                }
                .nav-btn:hover {
                    background: #eef4ff;
                    transform: translateX(3px);
                }
                .nav-btn.active {
                    background: #e3ecff;
                    font-weight: 600;
                    border-left: 4px solid #2563eb;
                }

                .text-purple { color: #6f42c1; }
                .text-green { color: #0d8c31; }
                .text-orange { color: #ff7f32; }
                .text-gold { color: #c49b07; }
                .text-sky { color: #0ea5e9; }
                .text-red { color: #e11d48; }

                .sub-link {
                    font-size: 14px;
                    padding-left: 12px !important;
                    margin-bottom: 6px;
                    color: #666 !important;
                }
                .sub-link:hover {
                    background: #f1f6ff;
                    border-radius: 6px;
                }

                /* Desktop Sticky */
                @media (min-width: 768px) {
                    .sidebar {
                        width: 260px;
                        position: sticky;
                        top: 56px;
                        height: calc(100vh - 56px);
                        overflow-y: auto;
                        box-shadow: 2px 0 8px rgba(0,0,0,0.05);
                    }
                }

                /* Mobile Slide */
                @media (max-width: 768px) {
                    .sidebar {
                        position: fixed;
                        top: 0;
                        left: -260px;
                        width: 240px;
                        height: 100%;
                        z-index: 1050;
                        transition: all 0.3s ease;
                        box-shadow: 0 0 12px rgba(0,0,0,0.15);
                    }
                    .sidebar.show {
                        left: 0;
                    }
                }
                    @media (max-width: 768px) {
  .sidebar {
      height: 100%;
      overflow-y: auto;
  }
}

            `}</style>
        </div>
    );
}
